import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { lc } from '@/i18n/copy';

const copy = {
  en: { impact: (n: number) => `You've helped ${n} ${n === 1 ? 'person' : 'people'} express themselves.`, keep: 'Keep going — your words ripple further than you think.' },
  es: { impact: (n: number) => `Has ayudado a ${n} ${n === 1 ? 'persona' : 'personas'} a expresarse.`, keep: 'Sigue así — tus palabras llegan más lejos de lo que crees.' },
  fr: { impact: (n: number) => `Vous avez aidé ${n} ${n === 1 ? 'personne' : 'personnes'} à s'exprimer.`, keep: 'Continuez — vos mots portent plus loin que vous ne le pensez.' },
  pt: { impact: (n: number) => `Você ajudou ${n} ${n === 1 ? 'pessoa' : 'pessoas'} a se expressar.`, keep: 'Continue — suas palavras alcançam mais do que você imagina.' },
  ar: { impact: (n: number) => `لقد ساعدت ${n} ${n === 1 ? 'شخص' : 'أشخاص'} على التعبير عن أنفسهم.`, keep: 'استمر — كلماتك تصل أبعد مما تظن.' },
  ja: { impact: (n: number) => `${n}人の表現をお手伝いしました。`, keep: '続けてください — あなたの言葉は思っている以上に広がっています。' },
  ko: { impact: (n: number) => `${n}명이 마음을 표현하도록 도왔습니다.`, keep: '계속하세요 — 당신의 말은 생각보다 더 멀리 퍼집니다.' },
  id: { impact: (n: number) => `Kamu telah membantu ${n} orang mengekspresikan diri.`, keep: 'Terus lanjutkan — kata-katamu menjangkau lebih jauh dari yang kamu kira.' },

  hi: { impact: (n: number) => `You've helped ${n} ${n === 1 ? 'person' : 'people'} express themselves.`, keep: 'चलते रहें — आपके शब्द आपकी सोच से कहीं अधिक दूर तक फैलते हैं।' },
};

interface ImpactNudgeProps {
  publishedCount: number;
}

export function ImpactNudge({ publishedCount }: ImpactNudgeProps) {
  const { language } = useLanguage();
  const c = lc(copy, language);

  if (publishedCount < 1) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5 }}
      className="flex items-start gap-3 p-4 rounded-lg bg-accent/30 border border-accent/50"
    >
      <Sparkles className="h-5 w-5 text-primary shrink-0 mt-0.5" />
      <div className="space-y-0.5">
        <p className="text-sm font-medium text-foreground">
          {c.impact(publishedCount)}
        </p>
        <p className="text-xs text-muted-foreground">
          {c.keep}
        </p>
      </div>
    </motion.div>
  );
}
